"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.nuonoe = exports.firstNuon = exports.nuon = void 0;

/* 
    nuon: Not Undefined Or Null
    This function is used to validate variable is defined and non-null
    when the number 0 is among the variable's possible values domain.

    If you were to simply use: if(!variable), to check for not null and 
    'is defined', then you would exclude your 'variable === 0' cases.
*/
var nuon = function nuon(value) {
  if (value !== null && value !== undefined) {
    return true;
  } else return false;
};
/* 
    firstNuon: Utilizes the concept of nuon to return the first value
    in the given list whose value is defined and non-null.
*/


exports.nuon = nuon;

var firstNuon = function firstNuon(valueList) {
  for (var i = 0; i < valueList.length; i++) {
    if (nuon(valueList[i])) return valueList[i];
  }

  return null;
};
/*
    nuonoe: utilizes nuon logic and additionally confirms that if 
    a 'length' property is found, it is greater than 0
*/


exports.firstNuon = firstNuon;

var nuonoe = function nuonoe(value) {
  return value !== null && value !== undefined && (value.length === undefined || value.length > 0);
};
/* 
 * function to determine whether a given value is:
 * non-null, non-undefined, and if conditions array is present, 
 * that all condition functions (of form: condition(value) ) return TRUE
 */


exports.nuonoe = nuonoe;

var validate = function validate(value, conditions) {
  if (!nuon(value)) return false;

  if (conditions && conditions.length > 0) {
    for (var i = 0; i < conditions.length; i++) {
      if (conditions[i](value) === false) return false;
    }
  }

  return true;
};

exports.validate = validate;